import React from 'react';
import { Copy } from 'lucide-react';

interface IntentBannerProps {
    intentClass?: string;
    reasonCode?: string;
    traceId?: string;
    risk?: string;
}

const copyToClipboard = (value?: string) => {
    if (!value || typeof window === 'undefined') return;
    if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(value);
        return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

const IntentBanner: React.FC<IntentBannerProps> = ({ intentClass, reasonCode, traceId, risk }) => {
    return (
        <div className="mb-2 flex flex-wrap items-center gap-2 rounded-lg border border-slate-700/40 bg-slate-900/50 px-3 py-2 text-[11px] text-slate-300">
            <span className="rounded-full border border-violet-500/40 bg-violet-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-violet-200">
                Execution Required
            </span>
            <span className="text-slate-400">Intent:</span>
            <span className="text-slate-200">{intentClass ?? 'unknown'}</span>
            <span className="text-slate-400">Reason:</span>
            <span className="text-slate-200">{reasonCode ?? 'none'}</span>
            {risk && (
                <>
                    <span className="text-slate-400">Risk:</span>
                    <span className="text-slate-200">{risk}</span>
                </>
            )}
            {traceId && (
                <button
                    type="button"
                    onClick={() => copyToClipboard(traceId)}
                    className="inline-flex items-center gap-1 text-slate-400 hover:text-slate-200"
                >
                    Trace: {traceId}
                    <Copy className="w-3 h-3" />
                </button>
            )}
        </div>
    );
};

export default IntentBanner;
